// extracted by mini-css-extract-plugin
export var tosLink = "_4o-0";